<template>
    <span>

    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-btn dark fab x-small color="blue darken-3" v-on="on" @click="toggleDrawer">
                <v-icon dark>mdi mdi-filter</v-icon>
            </v-btn>
        </template>
        <span>Apply filter</span>
    </v-tooltip>
       <portal to="destination">
                                      <h3 class="font-weight-bold  text-center mb-2">Filters</h3>
           <slot/>
       </portal>
     </span>
</template>

<script>
    export default {
        name: "SidebarFilterButton",
        methods: {
            toggleDrawer() {
                this.$store.commit('Notification/toggleFilterDrawer')
            }
        }
    }
</script>
